export default __webpack_public_path__ + "static/media/233.bd53d06c.png";